import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDevicesLocations } from '../../services/MapsService';
import { LocationDevicesResponse } from '../../types/Maps';
import { FeaturesManagement } from '../../../featuresControl';

function useGetDevicesLocations(fleetId: string, query: string): UseQueryResult<LocationDevicesResponse> {
  return useQuery(
    ['devicesLocations', fleetId, query],
    async (): Promise<LocationDevicesResponse> => getDevicesLocations(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      keepPreviousData: true,
    },
  );
}

export default useGetDevicesLocations;
